import { render, staticRenderFns } from "./AppToast.vue?vue&type=template&id=0230b061"
import script from "./AppToast.vue?vue&type=script&lang=ts"
export * from "./AppToast.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports